/* ==========================================================================
   LUNÉA — Megamenu gedrag
   - hover-intent (opent pas na korte vertraging, sluit met uitloop)
   - volledig toetsenbord-toegankelijk (Tab, Enter, Escape)
   - werkt in de theme editor (herinitialiseert bij section:load)
   ========================================================================== */
(function () {
  'use strict';

  var OPEN_DELAY = 110;
  var CLOSE_DELAY = 180;

  function LuneaMegaMenu(root) {
    this.root = root;
    this.items = Array.prototype.slice.call(
      root.querySelectorAll('.lumm__item--has-panel')
    );
    this.openTimer = null;
    this.closeTimer = null;
    this.current = null;

    if (!this.items.length) return;

    this.onDocKeydown = this.handleDocKeydown.bind(this);
    this.onDocClick = this.handleDocClick.bind(this);

    this.bind();
    root.setAttribute('data-lumm-ready', 'true');
  }

  LuneaMegaMenu.prototype.bind = function () {
    var self = this;

    this.items.forEach(function (item) {
      var link = item.querySelector('.lumm__link');
      var panel = item.querySelector('.lumm__panel');
      if (!link || !panel) return;

      item.addEventListener('mouseenter', function () {
        self.scheduleOpen(item);
      });

      item.addEventListener('mouseleave', function () {
        self.scheduleClose();
      });

      // Toetsenbord: openen zodra de trigger focus krijgt
      link.addEventListener('focus', function () {
        self.open(item);
      });

      // Op touch opent de eerste tik het paneel in plaats van te navigeren
      link.addEventListener('click', function (event) {
        if (!self.isTouch()) return;
        if (self.current !== item) {
          event.preventDefault();
          self.open(item);
        }
      });

      // Focus verlaat het hele item -> sluiten
      item.addEventListener('focusout', function (event) {
        if (!event.relatedTarget || !item.contains(event.relatedTarget)) {
          self.close(item);
        }
      });
    });

    document.addEventListener('keydown', this.onDocKeydown);
    document.addEventListener('click', this.onDocClick);
  };

  LuneaMegaMenu.prototype.isTouch = function () {
    return window.matchMedia('(hover: none)').matches;
  };

  LuneaMegaMenu.prototype.scheduleOpen = function (item) {
    var self = this;
    window.clearTimeout(this.closeTimer);
    window.clearTimeout(this.openTimer);
    // Al een paneel open? Dan direct wisselen, dat voelt natuurlijker.
    if (this.current && this.current !== item) {
      this.open(item);
      return;
    }
    this.openTimer = window.setTimeout(function () {
      self.open(item);
    }, OPEN_DELAY);
  };

  LuneaMegaMenu.prototype.scheduleClose = function () {
    var self = this;
    window.clearTimeout(this.openTimer);
    window.clearTimeout(this.closeTimer);
    this.closeTimer = window.setTimeout(function () {
      self.closeAll();
    }, CLOSE_DELAY);
  };

  LuneaMegaMenu.prototype.open = function (item) {
    if (!item) return;
    window.clearTimeout(this.closeTimer);

    this.items.forEach(function (other) {
      if (other === item) return;
      other.classList.remove('is-open');
      var otherLink = other.querySelector('.lumm__link');
      if (otherLink) otherLink.setAttribute('aria-expanded', 'false');
    });

    item.classList.add('is-open');
    var link = item.querySelector('.lumm__link');
    if (link) link.setAttribute('aria-expanded', 'true');

    this.root.classList.add('is-active');
    this.current = item;
  };

  LuneaMegaMenu.prototype.close = function (item) {
    if (!item) return;
    item.classList.remove('is-open');
    var link = item.querySelector('.lumm__link');
    if (link) link.setAttribute('aria-expanded', 'false');
    if (this.current === item) this.current = null;
    if (!this.root.querySelector('.lumm__item.is-open')) {
      this.root.classList.remove('is-active');
    }
  };

  LuneaMegaMenu.prototype.closeAll = function () {
    var self = this;
    this.items.forEach(function (item) {
      self.close(item);
    });
    this.root.classList.remove('is-active');
    this.current = null;
  };

  LuneaMegaMenu.prototype.handleDocKeydown = function (event) {
    if (event.key !== 'Escape' && event.keyCode !== 27) return;
    if (!this.current) return;
    var link = this.current.querySelector('.lumm__link');
    this.closeAll();
    if (link) link.focus();
  };

  LuneaMegaMenu.prototype.handleDocClick = function (event) {
    if (!this.current) return;
    if (this.root.contains(event.target)) return;
    this.closeAll();
  };

  LuneaMegaMenu.prototype.destroy = function () {
    document.removeEventListener('keydown', this.onDocKeydown);
    document.removeEventListener('click', this.onDocClick);
    window.clearTimeout(this.openTimer);
    window.clearTimeout(this.closeTimer);
  };

  var instances = [];

  function init() {
    instances.forEach(function (instance) {
      instance.destroy();
    });
    instances = [];

    var roots = document.querySelectorAll('.lumm');
    Array.prototype.forEach.call(roots, function (root) {
      instances.push(new LuneaMegaMenu(root));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: opnieuw opbouwen na het herladen van de header
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('.lumm')) init();
  });
  document.addEventListener('shopify:section:select', function (event) {
    if (event.target && event.target.querySelector('.lumm')) init();
  });
})();
